import { Controller } from "@hotwired/stimulus"

const SUN = '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>'
const MOON = '<path d="M21 12.8A9 9 0 1111.2 3 7 7 0 0021 12.8z"/>'

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    const saved = localStorage.getItem("afagh-theme")
    if (saved) this.apply(saved)
  }

  toggle() {
    const next = document.documentElement.dataset.theme === "dark" ? "light" : "dark"
    localStorage.setItem("afagh-theme", next)
    this.apply(next)
  }

  apply(theme) {
    document.documentElement.dataset.theme = theme
    this.iconTarget.innerHTML = theme === "dark" ? MOON : SUN
    window.dispatchEvent(new CustomEvent("afagh:theme-changed"))
  }
}
